import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    users: [],
    user: {},
    circle: [],
}


export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        getUsers: (state, action) => {

            return {
                ...state,
                users: action.payload
            };
        },
        getUserCircle: (state, action) => {
            console.log(action.payload)
            return {
                ...state,
                circle: action.payload
            };
        },
        addUsers: (state, action) => {

            return {
                ...state,
                users: {
                    ...state.users,
                    users: [...state.users.users, action.payload]
                },
            };
        },
        getUserById: (state, action) => {
            console.log(action.payload)
            return {
                ...state,
                user: action.payload,
            };
        },

        updateUserById: (state, action) => {
            console.log(action.payload)
            return {
                ...state,
                users: {
                    ...state.users,
                    users: state.users.users.map(item => item._id == action.payload._id ? action.payload : item)
                },
            };
        },

        deleteUserById: (state, action) => {
            return {
                ...state,
                users: {
                    ...state.users,
                    Collection: state.users.Collection.filter(item => item._id !== action.payload)
                },
            };
        }

    }
})


export const { getUsers, addUsers, getUserById,getUserCircle, updateUserById, deleteUserById } = userSlice.actions
export default userSlice.reducer